import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { Block } from "../Block";
import { BoardContainer } from "../BoardContainer";
import { BlocksScrollingModel } from "../niche/BlocksScrolinglModel";
import * as Templok from "@ravalmatic/templok-engine";

export class ReRollDemoContainer extends Phaser.GameObjects.Container {

    private wheel: Phaser.GameObjects.Image;
    private glow: Phaser.GameObjects.Image;
    private reRollPieceContainer: Phaser.GameObjects.Container;
    private randomBlockDataArray: Templok.BlockData [];
    private blocksScrollingModel: BlocksScrollingModel;
    private scrolling: boolean;
    private scrollingBlocks: Block[];
    private block: Block;
    private glowTween: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.scrolling = false;

        const title = new Phaser.GameObjects.Text(this.scene, 30, -140, "RE-ROLL FEATURE", {fontFamily: "Futura-Medium", fontSize: "22px", color: "#FFFFFF", align: "center"});
        title.setOrigin(.5);
        this.add(title);

        const reRollButton = new Phaser.GameObjects.Image(this.scene, -100, -140, "texture_atlas_2", "btn_reroll_on_off");
        reRollButton.setScale(.8);
        this.add(reRollButton);

        const wheelContainer = new Phaser.GameObjects.Container(this.scene);
        wheelContainer.setScale(.85);
        this.add(wheelContainer);

        this.wheel = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "stone_wheel");
        wheelContainer.add(this.wheel);

        this.glow = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "stone_wheel_glow");
        this.glow.visible = false;
        wheelContainer.add(this.glow);

        this.reRollPieceContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.reRollPieceContainer);

        this.block = new Block(this.scene, null, {
            id: -1,
            n: 5,
            data: [34956, 7936, 50244, 63488],
            i: 0
        }, 1, 0, 0, true);
        this.reRollPieceContainer.add(this.block);

        const border = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "stone_wheel_light");
        wheelContainer.add(border);

        const maskShape = new Phaser.GameObjects.Graphics(this.scene);
        maskShape.fillStyle(0x00FF00);
        maskShape.fillCircle(0, 0, 82);
        maskShape.x = GameConstants.GAME_WIDTH / 2 + 150; 
        maskShape.y = GameConstants.GAME_HEIGHT / 2 - 90 * GameVars.scaleY; 
        maskShape.scaleX = .85;
        maskShape.scaleY = GameVars.scaleY * .85;
        
        this.reRollPieceContainer.mask = maskShape.createGeometryMask();   

        this.setRandomBlocksArray();

        this.scene.time.delayedCall(1000, function(): void {
            this.reRoll({
                id: 1,
                n: Templok.BlockType.B_1_1.n,
                data: Templok.BlockType.B_1_1.data,
                i: Math.floor(Math.random() * 3)
            });
        }, [], this);  
    }

    public update(): void {

        if (this.scrolling) {

            this.blocksScrollingModel.update(true);

            for (let i = 0; i < this.scrollingBlocks.length; i++) {

                const block = this.scrollingBlocks[i];
                const scrollingData = this.blocksScrollingModel.getScrollingData(block.blockData.id);
                block.y = scrollingData.y;
            }

            if (!this.blocksScrollingModel.scrolling) {

                this.scrolling = false;

                this.onBlockReRolled();
            }
        }
    }

    private reRoll(blockData: Templok.BlockData): void {

        if (typeof this.scene === "undefined") {
            return;
        }

        this.scrolling = true;

        this.block.enable();

        this.scrollingBlocks = [this.block];

        this.block.parentContainer.remove(this.block);
        this.reRollPieceContainer.add(this.block);

        // cogemos 4 bloques random que no coincidan con el que se va a dar al jugador
        // ponemos el bloque en cuestión en un array y hacemos shuffle
        let tmpBlockData: Templok.BlockData[] = [];

        this.shuffleArray(this.randomBlockDataArray);

        // el nuevo bloque
        tmpBlockData.push(blockData);

        let n = 0;
        let i = 0;

        while (n < 4) {

            const randomBlockData = this.randomBlockDataArray[i];

            if (randomBlockData.data[randomBlockData.i] !== blockData.data[blockData.i] && randomBlockData.data[randomBlockData.i] !== this.block.blockData.data[this.block.blockData.i]) {
                n ++;
                randomBlockData.id = blockData.id + n;
                tmpBlockData.push(randomBlockData);
            }

            i ++;
        }

        this.shuffleArray(tmpBlockData);

        for (let i = 0; i < tmpBlockData.length; i ++) {

            const block = new Block(this.scene, null, tmpBlockData[i], this.block.color, 0, 0, true);
            this.reRollPieceContainer.add(block);

            if (block.blockData === blockData) {
                this.block = block;
            }

            this.scrollingBlocks.push(block);
        }

        // posicionar los bloques en vertical
        for (let i = 1; i < this.scrollingBlocks.length; i ++) {

            let py = -(this.scrollingBlocks[0].blockHeight + 1) * BoardContainer.CELL_SIZE * .5 * Block.SCALE_ON_DISPENSER;

            for (let j = 1; j < i; j ++) {
                py -= (this.scrollingBlocks[j].blockHeight + 1) * BoardContainer.CELL_SIZE * Block.SCALE_ON_DISPENSER;
            }

            py -= (this.scrollingBlocks[i].blockHeight + 1) * BoardContainer.CELL_SIZE * .5 * Block.SCALE_ON_DISPENSER;

            this.scrollingBlocks[i].y += py;
        }

        // emular
        this.blocksScrollingModel = new BlocksScrollingModel(this.block.blockData.id);

        let f: number;

        for (f = 100; f < 1000; f ++) {

            this.blocksScrollingModel.reset(this.scrollingBlocks, f);

            while (this.blocksScrollingModel.scrolling) {
                this.blocksScrollingModel.update(true);
            }

            if (this.blocksScrollingModel.success) {
                break;
            }
        }

        this.blocksScrollingModel.reset(this.scrollingBlocks, f);

        this.glow.visible = true;
        this.glow.alpha = 0;

        this.glowTween = this.scene.tweens.add({
            targets: this.glow,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            onComplete: function(): void {

                if (typeof this.scene === "undefined") {
                    return;
                }

                this.glowTween = this.scene.tweens.add({
                    targets: this.glow,
                    alpha: .65,
                    ease: Phaser.Math.Easing.Cubic.InOut,
                    duration: 500,
                    repeat: -1,
                    yoyo: true
                });
            },
            onCompleteScope: this
        });
    }

    private onBlockReRolled(): void {

        this.block.y = this.block.py;
                
        this.block.isOnNiche = true;
        this.block.parentContainer.remove(this.block);
        this.add(this.block);
        
        for (let i = 0; i < this.scrollingBlocks.length; i++) {

            const block = this.scrollingBlocks[i];

            if (block !== this.block) {
                block.removeFakeBlockFromNiche();
            }   
        }

        this.glowTween.remove();
        this.glowTween = null;
        
        this.scene.tweens.add({
            targets: this.glow,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            onComplete: function(): void {
                this.glow.visible = false;
            },
            onCompleteScope: this
        });

        const randomBlockData = this.randomBlockDataArray[Math.floor(Math.random() * this.randomBlockDataArray.length)];
        randomBlockData.id = this.block.blockData.id + 1;

        this.scene.time.delayedCall(1500, function(): void {
            this.reRoll(randomBlockData);
        }, [], this);  
    }

    private setRandomBlocksArray(): void {

        this.randomBlockDataArray = [];

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_1_1.n,
            data: Templok.BlockType.B_1_1.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_2_1.n,
            data: Templok.BlockType.B_2_1.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_3_1.n,
            data: Templok.BlockType.B_3_1.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_3_2.n,
            data: Templok.BlockType.B_3_2.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_4_1.n,
            data: Templok.BlockType.B_4_1.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_4_2.n,
            data: Templok.BlockType.B_4_2.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_4_3.n,
            data: Templok.BlockType.B_4_3.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_4_4.n,
            data: Templok.BlockType.B_4_4.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_4_5.n,
            data: Templok.BlockType.B_4_5.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_4_6.n,
            data: Templok.BlockType.B_4_6.data,
            i: Math.floor(Math.random() * 3)
        });

        this.randomBlockDataArray.push({
            id: -1,
            n: Templok.BlockType.B_4_7.n,
            data: Templok.BlockType.B_4_7.data,
            i: Math.floor(Math.random() * 3)
        });
    }

    private shuffleArray(array: any []): void {

        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    }
}
